import { ReactElement, useRef, useState } from 'react';
import { Message } from '@messageformat/react';
import { Button } from '@op/opds.opux';
import { IconAdd } from '@op/opds.opux-icons/action';
import DreamInput from './DreamInput';
import TotalTile from './TotalTile';

const Dreams = (): ReactElement => {
  const [dreams, setDreams] = useState([{ dream: 'default', cost: 0, id: 0 }]);
  const nextId = useRef(1);

  const addNewDream = (): void => {
    const id = nextId.current;
    nextId.current += 1;
    setDreams([...dreams, { dream: 'default', cost: 0, id }]);
  };

  const sum = dreams.reduce((acc, current) => {
    return acc + current.cost;
  }, 0);

  return (
    <>
      {dreams.map((element, index) => {
        return (
          <DreamInput
            key={element.id}
            dreams={dreams}
            setDreams={setDreams}
            index={index}
          />
        );
      })}
      <div className="investoracademy-vertical-flex-align">
        <Button icon={IconAdd} onClick={addNewDream} style={{ width: '160px' }}>
          <Message id="course4.question2.button" />
        </Button>
      </div>
      <TotalTile sum={sum} messageId="course4.planner_total" />
    </>
  );
};

export default Dreams;
